import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

// 自动导入 modules 文件夹下的模块
const modules = {};
const files = require.context("./modules", false, /\.js$/);

files.keys().forEach((key) => {
  const moduleName = key.replace(/(\.\/|\.js)/g, ""); // 去掉 ./ 和 .js
  modules[moduleName] = files(key).default;
});

export default new Vuex.Store({
    state: {
      showLeftMenu: false, // 左侧菜单开关
      showbg: false, // 背景图片开关
      menuName: "", // 当前菜单名称
    },
  mutations: {
    TOGGLE_LEFT_MENU(state) {
      state.showLeftMenu = !state.showLeftMenu;
    },
    TOGGLE_BG(state) {
      state.showbg = !state.showbg;
    },
    SET_MENU_NAME(state, name) {
      state.menuName = name;
    },
  },
  modules, // 自动加载 modules
});



// WEBPACK FOOTER //
// ./src/store/index.js